import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-location-sn.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-location-sn.component.scss?ngResource";
import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { AppControllerService } from "../../../../app-controller.service";
import { MapService } from "../../../../map/shared/map.service";
import { RequestStatusService } from "../../../../shared/services/request-status/request-status.service";
import { MapTools } from "../../../../map/shared/map.tools";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../shared/models/alert";
import { ApiProxyConstants } from "../../../../shared/constants/api-constants/api-proxy.constants";
import { AppConfig } from "../../../../app.config";
import { AppRoutingConstants } from "../../../../app-routing.constants";
import { UrlConstants } from "../../../../shared/constants/url.constants";
import { CreateApplicationLocationSnConstants } from "./create-application-location-sn.constant";
export let CreateApplicationLocationSnComponent = class CreateApplicationLocationSnComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    mapService;
    requestStatusService;
    mapTools;
    changeDetectorRefs;
    activeTabIndex;
    locationForm;
    dropdownPlaceholderMessage = SharedConstants.NO_OPTION_SELECTED;
    showPrivateStreetAreaOrEstateNameField = true;
    showCurrentNameField = true;
    showFeatureTypeField = true;
    showRequiredAsteriskForTheAreaEstateNameField = false;
    showRequiredAsteriskForTheCurrentNameField = false;
    streetOrFeatureLookUps = CreateApplicationLocationSnConstants.STREET_OR_FEATURE_LOOKUPS;
    publicOrPrivateLookUps = CreateApplicationLocationSnConstants.PUBLIC_OR_PRIVATE_LOOKUPS;
    isNewDevelopmentLookUps = CreateApplicationLocationSnConstants.IS_NEW_DEVELOPMENT_LOOKUPS;
    haveExistingNameLookUps = CreateApplicationLocationSnConstants.HAVE_EXISTING_NAME_LOOKUPS;
    descriptionLabel1 = CreateApplicationLocationSnConstants.DESCRIPTION_LABEL_1;
    descriptionLabel2 = CreateApplicationLocationSnConstants.DESCRIPTION_LABEL_2;
    descriptionLabel3 = CreateApplicationLocationSnConstants.DESCRIPTION_LABEL_3;
    validationMessages = CreateApplicationLocationSnConstants.VALIDATION_MESSAGES;
    streetOrFeatureLabel = CreateApplicationLocationSnConstants.STREET_OR_FEATURE_LABEL;
    removeFeatureLabel = CreateApplicationLocationSnConstants.REMOVE_FEATURE_LABEL;
    publicOrPrivateLabel = CreateApplicationLocationSnConstants.PUBLIC_OR_PRIVATE_LABEL;
    privateStreetAreaOrEstateNameLabel = CreateApplicationLocationSnConstants.PRIVATE_STREET_AREA_OR_ESTATE_NAME_LABEL;
    isNewDevelopmentLabel = CreateApplicationLocationSnConstants.IS_NEW_DEVELOPMENT_NAME_LABEL;
    haveExistingNameLabel = CreateApplicationLocationSnConstants.HAVE_EXISTING_NAME_LABEL;
    currentNameLabel = CreateApplicationLocationSnConstants.CURRENT_NAME_LABEL;
    locationDescriptionLabel = CreateApplicationLocationSnConstants.LOCATION_DESCRIPTION_LABEL;
    wardLabel = CreateApplicationLocationSnConstants.WARD_LABEL;
    proposedNameLabel = CreateApplicationLocationSnConstants.PROPOSED_NAME_LABEL;
    proposedNameLanguageLabel = CreateApplicationLocationSnConstants.PROPOSED_NAME_LANGUAGE_LABEL;
    proposedNameMeaningLabel = CreateApplicationLocationSnConstants.PROPOSED_NAME_MEANING_LABEL;
    proposedNameOriginLabel = CreateApplicationLocationSnConstants.PROPOSED_NAME_ORIGIN_LABEL;
    proposedAlternativeNameLabel = CreateApplicationLocationSnConstants.PROPOSED_ALTERNATIVE_NAME_LABEL;
    languageOfTheAlternativeNameLabel = CreateApplicationLocationSnConstants.LANGUAGE_OF_THE_ALTERNATIVE_NAME_LABEL;
    meaningAlternativeNameLabel = CreateApplicationLocationSnConstants.MEANING_OF_THE_ALTERNATIVE_NAME_LABEL;
    featureTypeLabel = CreateApplicationLocationSnConstants.FEATURE_TYPE_LABEL;
    reasonForChangeLabel = CreateApplicationLocationSnConstants.REASON_FOR_CHANGE_LABEL;
    featuresFormArrayName = CreateApplicationLocationSnConstants.FEATURES_FORM_ARRAY_NAME;
    locationFormGroupName = CreateApplicationLocationSnConstants.LOCATION_FORM_GROUP_NAME;
    streetOrFeatureFormControlName = CreateApplicationLocationSnConstants.STREET_OR_FEATURE_FORM_CONTROL_NAME;
    publicOrPrivateFormControlName = CreateApplicationLocationSnConstants.PUBLIC_OR_PRIVATE_FORM_CONTROL_NAME;
    privateStreetAreaOrEstateNameFormControlName = CreateApplicationLocationSnConstants.PRIVATE_STREET_AREA_OR_ESTATE_NAME_FORM_CONTROL_NAME;
    isNewDevelopmentFormControlName = CreateApplicationLocationSnConstants.IS_NEW_DEVELOPMENT_FORM_CONTROL_NAME;
    haveExistingNameFormControlName = CreateApplicationLocationSnConstants.HAVE_EXISTING_NAME_FORM_CONTROL_NAME;
    currentNameFormControlName = CreateApplicationLocationSnConstants.CURRENT_NAME_FORM_CONTROL_NAME;
    locationDescriptionFormControlName = CreateApplicationLocationSnConstants.LOCATION_DESCRIPTION_FORM_CONTROL_NAME;
    wardFormControlName = CreateApplicationLocationSnConstants.WARD_FORM_CONTROL_NAME;
    proposedNameFormControlName = CreateApplicationLocationSnConstants.PROPOSED_NAME_FORM_CONTROL_NAME;
    proposedNameLanguageFormControlName = CreateApplicationLocationSnConstants.PROPOSED_NAME_LANGUAGE_FORM_CONTROL_NAME;
    proposedNameMeaningFormControlName = CreateApplicationLocationSnConstants.PROPOSED_NAME_MEANING_FORM_CONTROL_NAME;
    proposedAlternativeNameFormArrayName = CreateApplicationLocationSnConstants.PROPOSED_ALTERNATIVE_NAME_FORM_CONTROL_NAME;
    proposedNameOriginFormControlName = CreateApplicationLocationSnConstants.PROPOSED_NAME_ORIGIN_FORM_CONTROL_NAME;
    featureTypeFormControlName = CreateApplicationLocationSnConstants.FEATURE_TYPE_FORM_CONTROL_NAME;
    reasonForChangeFormControlName = CreateApplicationLocationSnConstants.REASON_FOR_CHANGE_FORM_CONTROL_NAME;
    sketchTool;
    selectedGraphic = null;
    isMapLoaded = false;
    mapComponent;
    layerReference = "Feature graphics";
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, mapService, requestStatusService, mapTools, changeDetectorRefs) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.mapService = mapService;
        this.requestStatusService = requestStatusService;
        this.mapTools = mapTools;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    getFeatures() {
        return this.locationForm.get(this.featuresFormArrayName);
    }
    ngOnInit() {
        this.initForm();
        this.subscribeToSelectedPOI();
        this.subscribeToSelectedStreet();
        this.subscribeToClearGraphics();
        this.changeDetectorRefs.detectChanges();
    }
    ngAfterViewInit() {
        this.mapService.actionPOIEnabled = true;
        this.mapService.actionStreetEnabled = true;
    }
    mapLoaded() {
        this.isMapLoaded = true;
        this.syncMapGeometries();
        this.initializeSketchTools();
    }
    ngOnDestroy() {
        this.mapService.actionPOIEnabled = false;
        this.mapService.actionStreetEnabled = false;
        super.ngOnDestroy();
    }
    loadMetadata() {
    }
    hasControlValidator(control) {
        if (control.validator) {
            const validator = control.validator({});
            if (validator && validator.required) {
                return true;
            }
        }
    }
    onBtnAddAlternativeNameClicked(featureIndex) {
        const alternativeNameGroup = new FormGroup({
            id: new FormControl(0),
            deleted: new FormControl(false),
            name: new FormControl(null, Validators.required),
            language: new FormControl(null, Validators.required),
            meaning: new FormControl(null, Validators.required)
        });
        const alternativeNamesFromArray = this.getAlternativeNameFormControls(featureIndex);
        alternativeNamesFromArray.setValidators(Validators.required);
        alternativeNamesFromArray.updateValueAndValidity();
        alternativeNamesFromArray.push(alternativeNameGroup);
        this.changeDetectorRefs.markForCheck();
    }
    onBtnRemoveAlternativeNameClicked(featureIndex, alternativeDetailsIndex) {
        const alternativeNamesFromArray = this.getAlternativeNameFormControls(featureIndex);
        alternativeNamesFromArray.removeAt(alternativeDetailsIndex);
        if (alternativeNamesFromArray.controls.length > 0) {
            alternativeNamesFromArray.removeAt(alternativeDetailsIndex);
        }
        if (alternativeNamesFromArray.controls.length === 0) {
            this.resetAlternativeNames(alternativeNamesFromArray);
        }
        this.changeDetectorRefs.markForCheck();
    }
    getAlternativeNameFormControls(featureIndex) {
        return this.getFeatures().controls[featureIndex].get(this.proposedAlternativeNameFormArrayName);
    }
    onStreetOrFeatureSelected($event, featureIndex) {
        const streetOrFeatureSelected = $event.target.value;
        if (streetOrFeatureSelected?.trim()?.toLowerCase() === "street") {
            this.configureStreetSelected();
        }
        if (streetOrFeatureSelected?.trim()?.toLowerCase() === "feature") {
            this.configureFeatureSelected(featureIndex);
        }
    }
    onPublicOrPrivateSelected($event, featureIndex) {
        const publicOrPrivateSelected = $event.target.value;
        if (publicOrPrivateSelected?.trim()?.toLowerCase() === "public") {
            this.handlePublicValue(featureIndex);
        }
        if (publicOrPrivateSelected?.trim()?.toLowerCase() === "private") {
            this.handlePrivate(featureIndex);
        }
        this.changeDetectorRefs.detectChanges();
    }
    onHaveExistingNameSelected($event, featureIndex) {
        const haveExistingNameSelected = $event.target.value;
        if (haveExistingNameSelected?.trim()?.toLowerCase() === "yes") {
            this.handlePropertyOrFeatureHasExistingName(featureIndex);
        }
        if (haveExistingNameSelected?.trim()?.toLowerCase() === "no") {
            this.handlePropertyOrFeatureHasNoExistingName(featureIndex);
        }
    }
    onBtnRemoveFeature(featureIndex) {
        this.getFeatures().removeAt(featureIndex);
        this.syncMapGeometries();
        this.changeDetectorRefs.detectChanges();
    }
    initForm() {
        this.locationForm = this.aflaModuleStrategyService.form.get(this.locationFormGroupName);
        this.activeTabIndex = 0;
    }
    setPOIData(poiAttributes, geometry) {
        try {
            this.requestStatusService.showBusySpinner("GetPOIData");
            let newPOIFormGroup;
            if (poiAttributes) {
                newPOIFormGroup = this.setNewPOIFormGroup(poiAttributes, geometry);
            }
            else {
                newPOIFormGroup = this.createNewPOIFormGroup(geometry);
            }
            const url = this.getGPToolURL();
            const formData = this.getGPToolFormData(geometry);
            this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
                next: (trueCentroidResponse) => {
                    this.configureInitialFeatureForm(newPOIFormGroup);
                    this.setFeatureTrueCentroidData(newPOIFormGroup, trueCentroidResponse);
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetPOIData");
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("POIData", error, CRUDOperation.Get);
                    this.requestStatusService.removeBusySpinner("GetPOIData");
                }
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner("GetPOIData");
        }
    }
    syncMapGeometries() {
        const geometries = [];
        const features = this.getFeatures().controls;
        if (features.length > 0) {
            this.getFeatures().controls.forEach(featureControl => {
                const geom = featureControl.get("geometry").value;
                if (geom !== null) {
                    geometries.push(geom);
                }
            });
            if (geometries.length > 0) {
                this.mapComponent.addGeometriesOnMap(geometries, this.layerReference, true);
            }
            this.changeDetectorRefs.detectChanges();
        }
    }
    subscribeToSelectedPOI() {
        this.cleanupAfterDestroy(this.mapService.$selectedPOISubject).subscribe(poi => {
            if (poi !== null) {
                const objectId = this.featureDataAlternateColumnName(poi.attributes, "OBJECTID", "objectId");
                const featureHasAlreadyBeenAddedBefore = this.checkIfSelectedFeatureHasAlreadyBeenAdded(objectId);
                if (!featureHasAlreadyBeenAddedBefore) {
                    this.setPOIData(poi.attributes, poi.geometry);
                }
            }
        });
    }
    configureStreetSelected() {
        this.showStreetFields();
        this.changeDetectorRefs.detectChanges();
    }
    // show all fields that should be visible when streets is selected.
    showStreetFields() {
        this.showPrivateStreetAreaOrEstateNameField = true;
        this.showCurrentNameField = true;
    }
    configureFeatureSelected(featureIndex) {
        this.hideAreaEstateField(featureIndex);
    }
    handlePublicValue(featureIndex) {
        this.addFeatureTypeField(featureIndex);
        this.removeRequiredValidatorPrivateStreetAreaOrEstateNameField(featureIndex);
        this.hidePrivateStreetAreaOrEstateNameField(featureIndex);
    }
    handlePrivate(featureIndex) {
        this.hideFeatureTypeField(featureIndex);
        this.addRequiredValidatorOnTheAreaEstateNameField(featureIndex);
        this.displayPrivateStreetAreaOrEstateNameField(featureIndex);
    }
    displayPrivateStreetAreaOrEstateNameField(featureIndex) {
        const streetOrFeatureValue = this.getFeatures().controls[featureIndex].get(this.streetOrFeatureFormControlName).value;
        if (streetOrFeatureValue.trim().toLowerCase() === "street") {
            this.showPrivateStreetAreaOrEstateNameField = true;
            this.showRequiredAsteriskForTheAreaEstateNameField = true;
            const areaEstateNameControl = this.getFeatures().controls[featureIndex].get(this.privateStreetAreaOrEstateNameFormControlName);
            areaEstateNameControl.enable();
            areaEstateNameControl.addValidators(Validators.required);
            areaEstateNameControl.updateValueAndValidity();
        }
    }
    hideFeatureTypeField(featureIndex) {
        const featureTypeControl = this.getFeatures().controls[featureIndex].get(this.featureTypeFormControlName);
        featureTypeControl.clearValidators();
        featureTypeControl.reset("");
        featureTypeControl.disable();
        this.showFeatureTypeField = false;
    }
    addRequiredValidatorOnTheAreaEstateNameField(featureIndex) {
        const areaEstateNameControl = this.getFeatures().controls[featureIndex].get(this.privateStreetAreaOrEstateNameFormControlName);
        areaEstateNameControl.enable();
        areaEstateNameControl.addValidators(Validators.required);
        this.showRequiredAsteriskForTheAreaEstateNameField = true;
        areaEstateNameControl.updateValueAndValidity();
    }
    removeRequiredValidatorPrivateStreetAreaOrEstateNameField(featureIndex) {
        const streetOrFeatureValue = this.getFeatures().controls[featureIndex].get(this.streetOrFeatureFormControlName).value;
        if (streetOrFeatureValue.trim().toLowerCase() === "street") {
            const areaEstateNameControl = this.getFeatures().controls[featureIndex].get(this.privateStreetAreaOrEstateNameFormControlName);
            areaEstateNameControl.enable();
            areaEstateNameControl.clearValidators();
            areaEstateNameControl.setValue("");
            areaEstateNameControl.updateValueAndValidity();
        }
    }
    hidePrivateStreetAreaOrEstateNameField(featureIndex) {
        const streetOrFeatureValue = this.getFeatures().controls[featureIndex].get(this.streetOrFeatureFormControlName).value;
        if (streetOrFeatureValue.trim().toLowerCase() === "street") {
            this.showRequiredAsteriskForTheAreaEstateNameField = false;
            this.showPrivateStreetAreaOrEstateNameField = false;
        }
    }
    addFeatureTypeField(featureIndex) {
        const streetOrFeatureValue = this.getFeatures().controls[featureIndex].get(this.streetOrFeatureFormControlName).value;
        const featureTypeControl = this.getFeatures().controls[featureIndex].get(this.featureTypeFormControlName);
        // only show feature filed if the feature is public
        if (streetOrFeatureValue.trim().toLowerCase() === "feature") {
            this.showFeatureTypeField = true;
            featureTypeControl.enable();
            featureTypeControl.addValidators(Validators.required);
            featureTypeControl.updateValueAndValidity();
        }
    }
    hideAreaEstateField(featureIndex) {
        this.removeRequiredValidatorPrivateStreetAreaOrEstateNameField(featureIndex);
        this.showPrivateStreetAreaOrEstateNameField = false;
    }
    handlePropertyOrFeatureHasExistingName(featureIndex) {
        this.addRequiredValidatorOnTheCurrentNameField(featureIndex);
    }
    addRequiredValidatorOnTheCurrentNameField(featureIndex) {
        const currentNameControl = this.getFeatures().controls[featureIndex].get(this.currentNameFormControlName);
        currentNameControl.addValidators(Validators.required);
        this.showRequiredAsteriskForTheCurrentNameField = true;
        currentNameControl.updateValueAndValidity();
    }
    handlePropertyOrFeatureHasNoExistingName(featureIndex) {
        this.removeRequiredValidatorOnTheCurrentNameField(featureIndex);
    }
    removeRequiredValidatorOnTheCurrentNameField(featureIndex) {
        const currentNameControl = this.getFeatures().controls[featureIndex].get(this.currentNameFormControlName);
        currentNameControl.clearValidators();
        this.showRequiredAsteriskForTheCurrentNameField = false;
        currentNameControl.updateValueAndValidity();
    }
    setStreetData(streetAttributes, geometry) {
        try {
            this.requestStatusService.showBusySpinner("GetPOIData");
            let newStreetFormGroup;
            if (streetAttributes) {
                newStreetFormGroup = this.setNewStreetsFormGroup(streetAttributes, geometry);
            }
            else {
                newStreetFormGroup = this.createNewStreetsFormGroup(geometry);
            }
            const url = this.getGPToolURL();
            const formData = this.getGPToolFormData(geometry);
            this.applicationCreateService.getTrueCentroid(url, formData).subscribe({
                next: (trueCentroidResponse) => {
                    this.configureInitialFeatureForm(newStreetFormGroup);
                    this.setFeatureTrueCentroidData(newStreetFormGroup, trueCentroidResponse);
                    this.syncMapGeometries();
                    this.requestStatusService.removeBusySpinner("GetPOIData");
                },
                error: (error) => {
                    this.appController.handleServerErrorMessage("POIData", error, CRUDOperation.Get);
                    this.requestStatusService.removeBusySpinner("GetPOIData");
                }
            });
        }
        catch (e) {
            this.requestStatusService.removeBusySpinner("GetPOIData");
        }
    }
    subscribeToSelectedStreet() {
        this.cleanupAfterDestroy(this.mapService.$selectedStreetSubject).subscribe(street => {
            if (street !== null) {
                const objectId = this.featureDataAlternateColumnName(street.attributes, "OBJECTID", "objectId");
                const featureHasAlreadyBeenAddedBefore = this.checkIfSelectedFeatureHasAlreadyBeenAdded(objectId);
                if (!featureHasAlreadyBeenAddedBefore) {
                    this.setStreetData(street.attributes, street.geometry);
                }
            }
        });
    }
    featureDataAlternateColumnName(featureObject, name1, name2) {
        let returnVal = null;
        for (const [key, value] of Object.entries(featureObject)) {
            if (key === name1) {
                returnVal = featureObject.hasOwnProperty(name1) && value !== null ? value : null;
                break;
            }
            else if (key === name1.toLowerCase()) {
                returnVal = featureObject.hasOwnProperty(name1.toLowerCase()) && value !== null ? value : null;
                break;
            }
            else if (name2 && key === name2) {
                returnVal = featureObject.hasOwnProperty(name2) && value !== null ? value : null;
                break;
            }
        }
        return returnVal;
    }
    resetAlternativeNames(alternativeNamesFromArray) {
        alternativeNamesFromArray.reset();
    }
    checkIfSelectedFeatureHasAlreadyBeenAdded(objectId) {
        let featureHasAlreadyBeenAddedBefore = false;
        this.getFeatures().controls.forEach(item => {
            const check = item.get("objectId").value;
            if (check === objectId) {
                featureHasAlreadyBeenAddedBefore = true;
                this.appController.showMessage(CreateApplicationLocationSnConstants.DUPLICATE_MESSAGE, AlertType.Warning);
                this.requestStatusService.removeBusySpinner("GetPOIData");
            }
        });
        return featureHasAlreadyBeenAddedBefore;
    }
    createNewPOIFormGroup(geometry) {
        return new FormGroup({
            objectId: new FormControl(null),
            currentName: new FormControl(null, [Validators.required]),
            streetOrFeature: new FormControl({ value: "Feature", disabled: true }),
            publicOrPrivate: new FormControl(null, Validators.required),
            areaEstateName: new FormControl(null),
            isNewDevelopment: new FormControl(null, Validators.required),
            haveExistingName: new FormControl(null, Validators.required),
            locationDescription: new FormControl(null, Validators.required),
            ward: new FormControl(null, Validators.required),
            proposedName: new FormControl(null, Validators.required),
            proposedNameLanguage: new FormControl(null, Validators.required),
            proposedNameMeaning: new FormControl(null, Validators.required),
            proposedNameOrigin: new FormControl(null, Validators.required),
            alternativeNames: new FormArray([new FormGroup({
                    id: new FormControl(0),
                    deleted: new FormControl(false),
                    name: new FormControl(null, Validators.required),
                    language: new FormControl(null, Validators.required),
                    meaning: new FormControl(null, Validators.required)
                })], Validators.required),
            featureType: new FormControl(null, Validators.required),
            reasonForChange: new FormControl(null, Validators.required),
            geometry: new FormControl(geometry),
            centroid: new FormControl(null, [Validators.required]),
        });
    }
    setNewPOIFormGroup(poiObject, geometry) {
        return new FormGroup({
            objectId: new FormControl(this.featureDataAlternateColumnName(poiObject, "OBJECTID", "objectId")),
            currentName: new FormControl(this.featureDataAlternateColumnName(poiObject, "Name", "name"), [Validators.required]),
            streetOrFeature: new FormControl({ value: "Feature", disabled: true }),
            publicOrPrivate: new FormControl(null, Validators.required),
            areaEstateName: new FormControl(null),
            isNewDevelopment: new FormControl(null, Validators.required),
            haveExistingName: new FormControl(null, Validators.required),
            locationDescription: new FormControl(null, Validators.required),
            ward: new FormControl(this.featureDataAlternateColumnName(poiObject, "Ward", "ward"), Validators.required),
            proposedName: new FormControl(null, Validators.required),
            proposedNameLanguage: new FormControl(null, Validators.required),
            proposedNameMeaning: new FormControl(null, Validators.required),
            proposedNameOrigin: new FormControl(null, Validators.required),
            alternativeNames: new FormArray([new FormGroup({
                    id: new FormControl(0),
                    deleted: new FormControl(false),
                    name: new FormControl(this.featureDataAlternateColumnName(poiObject, "AlternativeName", "alternativeName"), Validators.required),
                    language: new FormControl(null, Validators.required),
                    meaning: new FormControl(null, Validators.required)
                })], Validators.required),
            featureType: new FormControl(null, Validators.required),
            reasonForChange: new FormControl(null, Validators.required),
            centroid: new FormControl(null, [Validators.required]),
            geometry: new FormControl(geometry),
        });
    }
    setNewStreetsFormGroup(streetAttributes, geometry) {
        return new FormGroup({
            objectId: new FormControl(this.featureDataAlternateColumnName(streetAttributes, "OBJECTID", "objectId")),
            currentName: new FormControl(this.featureDataAlternateColumnName(streetAttributes, "Name", "name"), [Validators.required]),
            centroid: new FormControl(null, [Validators.required]),
            streetOrFeature: new FormControl({ value: "Street", disabled: true }),
            publicOrPrivate: new FormControl(null, Validators.required),
            areaEstateName: new FormControl(null),
            isNewDevelopment: new FormControl(null, Validators.required),
            haveExistingName: new FormControl(null, Validators.required),
            locationDescription: new FormControl(null, Validators.required),
            geometry: new FormControl(geometry),
            ward: new FormControl(this.featureDataAlternateColumnName(streetAttributes, "Ward", "ward"), Validators.required),
            proposedName: new FormControl(null, Validators.required),
            proposedNameLanguage: new FormControl(null, Validators.required),
            proposedNameMeaning: new FormControl(null, Validators.required),
            proposedNameOrigin: new FormControl(null, Validators.required),
            alternativeNames: new FormArray([new FormGroup({
                    id: new FormControl(0),
                    deleted: new FormControl(false),
                    name: new FormControl(this.featureDataAlternateColumnName(streetAttributes, "AlternativeName", "alternativeName"), Validators.required),
                    language: new FormControl(null, Validators.required),
                    meaning: new FormControl(null, Validators.required)
                })], Validators.required),
            featureType: new FormControl(null, Validators.required),
            reasonForChange: new FormControl(null, Validators.required),
        });
    }
    createNewStreetsFormGroup(geometry) {
        return new FormGroup({
            objectId: new FormControl(null),
            currentName: new FormControl(null, [Validators.required]),
            centroid: new FormControl(null, [Validators.required]),
            streetOrFeature: new FormControl({ value: "Street", disabled: true }),
            publicOrPrivate: new FormControl(null, Validators.required),
            areaEstateName: new FormControl(null),
            isNewDevelopment: new FormControl(null, Validators.required),
            haveExistingName: new FormControl(null, Validators.required),
            locationDescription: new FormControl(null, Validators.required),
            geometry: new FormControl(geometry),
            ward: new FormControl(null, Validators.required),
            proposedName: new FormControl(null, Validators.required),
            proposedNameLanguage: new FormControl(null, Validators.required),
            proposedNameMeaning: new FormControl(null, Validators.required),
            proposedNameOrigin: new FormControl(null, Validators.required),
            alternativeNames: new FormArray([new FormGroup({
                    id: new FormControl(0),
                    deleted: new FormControl(false),
                    name: new FormControl(null, Validators.required),
                    language: new FormControl(null, Validators.required),
                    meaning: new FormControl(null, Validators.required)
                })], Validators.required),
            featureType: new FormControl(null, Validators.required),
            reasonForChange: new FormControl(null, Validators.required),
        });
    }
    getGPToolURL() {
        const proxyUrl = ApiProxyConstants.URL;
        const gpToolUrl = AppConfig.settings.arcGIS.servicesURL + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GEO_PROCESSING + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GP_SERVER + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.GET_TRUE_CENTROID + AppRoutingConstants.ROUTE_SEPERATOR + UrlConstants.EXECUTE;
        return `${proxyUrl}?${gpToolUrl}`;
    }
    getGPToolFormData(geometry) {
        const formData = new FormData();
        formData.append("f", "json");
        formData.append("geometryJSON", JSON.stringify(geometry));
        return formData;
    }
    setFeatureTrueCentroidData(newFormGroup, trueCentroidResponse) {
        const featuresArray = this.getFeatures();
        newFormGroup.get("centroid").setValue(trueCentroidResponse.results[0].value);
        featuresArray?.clear();
        featuresArray.push(newFormGroup);
        this.activeTabIndex = featuresArray.length - 1;
        this.changeDetectorRefs.detectChanges();
    }
    initializeSketchTools() {
        this.sketchTool = this.mapTools.getMapTool("drawTool");
        this.mapTools.expandWidget("drawTool");
        this.sketchTool.create("polygon");
        this.sketchTool.on("create", (event) => {
            if (event.state === "complete") {
                this.handleSketchComplete(event);
            }
            else if (event.state !== "cancel") {
                this.mapTools.sketchGraphicsLayer.removeAll();
            }
        });
    }
    handleSketchComplete(event) {
        this.selectedGraphic = event.graphic;
        if (this.selectedGraphic.geometry.type === "polygon") {
            this.setPOIData(this.selectedGraphic.attributes, this.selectedGraphic.geometry);
        }
        if (this.selectedGraphic.geometry.type === "polyline") {
            this.setStreetData(this.selectedGraphic.attributes, this.selectedGraphic.geometry);
        }
    }
    configureInitialFeatureForm(formGroup) {
        const streetOrFeatureValue = formGroup.get(this.streetOrFeatureFormControlName).value;
        if (streetOrFeatureValue?.toLowerCase() === "street") {
            this.configureFormsForSelectedStreet(formGroup);
        }
        if (streetOrFeatureValue?.toLowerCase() === "feature") {
            this.configureFormsForSelectedFeature(formGroup);
        }
        this.showOrHideCurrentNameField(formGroup);
    }
    configureFormsForSelectedFeature(formGroup) {
        this.clearValidationOfStreetSpecificFields(formGroup);
        this.hideStreetSpecificFields();
        this.clearFeatureTypeValidators(formGroup);
        this.hideFeatureSpecificFields();
        this.changeDetectorRefs.detectChanges();
    }
    clearValidationOfStreetSpecificFields(formGroup) {
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).enable();
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).reset("");
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).clearValidators();
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).disable();
        formGroup.get(this.currentNameFormControlName).enable();
        formGroup.get(this.currentNameFormControlName).reset("");
        formGroup.get(this.currentNameFormControlName).clearValidators();
        formGroup.get(this.currentNameFormControlName).disable();
        formGroup.updateValueAndValidity();
    }
    hideStreetSpecificFields() {
        this.showPrivateStreetAreaOrEstateNameField = false;
        this.showCurrentNameField = false;
    }
    clearFeatureTypeValidators(formGroup) {
        formGroup.get(this.featureTypeFormControlName).clearValidators();
        formGroup.updateValueAndValidity();
    }
    hideFeatureSpecificFields() {
        this.showFeatureTypeField = false;
    }
    configureFormsForSelectedStreet(formGroup) {
        this.showStreetSpecificFields();
        this.addStreetSpecificFieldsValidators(formGroup);
        this.clearValidationOfFeatureSpecificFields(formGroup);
        this.hideFeatureSpecificFields();
        this.changeDetectorRefs.detectChanges();
    }
    addStreetSpecificFieldsValidators(formGroup) {
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).enable();
        formGroup.get(this.privateStreetAreaOrEstateNameFormControlName).addValidators(Validators.required);
        this.showPrivateStreetAreaOrEstateNameField = true;
        formGroup.get(this.currentNameFormControlName).enable();
        formGroup.get(this.currentNameFormControlName).addValidators(Validators.required);
        this.showRequiredAsteriskForTheCurrentNameField = true;
        formGroup.updateValueAndValidity();
    }
    showStreetSpecificFields() {
        this.showPrivateStreetAreaOrEstateNameField = true;
        this.showCurrentNameField = true;
    }
    clearValidationOfFeatureSpecificFields(formGroup) {
        formGroup.get(this.featureTypeFormControlName).reset("");
        formGroup.get(this.featureTypeFormControlName).clearValidators();
        formGroup.get(this.featureTypeFormControlName).disable();
        formGroup.updateValueAndValidity();
    }
    showOrHideCurrentNameField(formGroup) {
        const currentNameValue = formGroup.get(this.currentNameFormControlName).value;
        if (currentNameValue) {
            this.showCurrentNameField = true;
            this.showRequiredAsteriskForTheCurrentNameField = true;
            formGroup.get(this.currentNameFormControlName).enable();
            formGroup.get(this.currentNameFormControlName).setValidators(Validators.required);
        }
        else {
            this.showRequiredAsteriskForTheCurrentNameField = false;
            formGroup.get(this.currentNameFormControlName).clearValidators();
            formGroup.get(this.currentNameFormControlName).setValue("");
            formGroup.get(this.currentNameFormControlName).updateValueAndValidity();
            formGroup.get(this.currentNameFormControlName).disable();
            this.showCurrentNameField = false;
        }
        formGroup.get(this.streetOrFeatureFormControlName).updateValueAndValidity();
    }
    subscribeToClearGraphics() {
        this.applicationCreateService.$clearLayerGraphicsSubject.subscribe({
            next: (clearGraphics) => {
                if (clearGraphics) {
                    this.getFeatures().clear();
                    this.mapComponent.removeGraphicsFromMap(this.layerReference);
                    this.mapTools.sketchGraphicsLayer.removeAll();
                    this.locationForm.reset();
                    this.changeDetectorRefs.detectChanges();
                }
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: MapService },
        { type: RequestStatusService },
        { type: MapTools },
        { type: ChangeDetectorRef }
    ];
    static propDecorators = {
        mapComponent: [{ type: ViewChild, args: ["esrimap", { static: true },] }]
    };
};
CreateApplicationLocationSnComponent = __decorate([
    Component({
        selector: "app-create-application-location-sn",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationLocationSnComponent);
